import React from 'react';
import { Slider } from '@mui/material';
import styles from '../ConfigurationForm.module.css';
import { sliderStyles } from '../theme/sliderStyles';

interface SliderControlProps {
  value: number;
  min: number;
  max: number;
  step?: number;
  onChange: (v: number) => void;
  badge?: React.ReactNode;
  formulaText?: React.ReactNode;
}

export const SliderControl = ({
  value,
  min,
  max,
  step,
  onChange,
  badge,
  formulaText
}: SliderControlProps) => {
  return (
    <>
      <Slider
        value={value}
        onChange={(_, v) => onChange(v as number)}
        min={min}
        max={max}
        step={step}
        sx={sliderStyles}
      />
      {formulaText && <span className={styles.formulaText}>{formulaText}</span>}
    </>
  );
};
